// extracted by mini-css-extract-plugin
module.exports =  {"img":"_93444fe79c--img--bJCx5","footer":"_93444fe79c--footer--p5Jhr"};